import { supabase } from '../supabaseClient';
import { API_URL } from './config';

export interface PaymentResponse {
  payment: {
    id: string;
    status: 'pending' | 'completed' | 'failed';
    amount: number;
    currency: string;
    created: string;
  };
  testMode?: boolean;
}

export async function createPayment(amount: number, description: string, testMode = true) {
  const session = await supabase.auth.getSession();
  const token = session.data.session?.access_token;

  if (!token) {
    throw new Error('Not authenticated');
  }

  const response = await fetch(`${API_URL}/api/payments/create`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({
      amount,
      currency: 'ZAR',
      description,
      test: testMode,
      customer: {
        name: session.data.session?.user?.user_metadata?.full_name ?? 'Customer',
        email: session.data.session?.user?.email,
      },
    }),
  });

  if (!response.ok) {
    const body = await response.json().catch(() => null);
    throw new Error(body?.error ?? 'Payment request failed');
  }

  return (await response.json()) as PaymentResponse;
}

export async function getAccountStatus() {
  const session = await supabase.auth.getSession();
  const token = session.data.session?.access_token;

  if (!token) {
    return null;
  }

  const response = await fetch(`${API_URL}/api/account`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  if (!response.ok) {
    return null;
  }

  return await response.json();
}
